var map = {
	"./cagayan-cert.webp": 1946,
	"./cert-bg.webp": 1947,
	"./isle-cert.webp": 1948,
	"./license-bg-cn.webp": 1949,
	"./license-bg-mobile-cn.webp": 1950,
	"./license-bg-mobile.webp": 1951,
	"./license-bg.webp": 1952,
	"./pagcor-cert.webp": 1953,
	"./page-bg.webp": 1954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 879;